/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\Burger.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday February 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Tuesday February 21st 2023 9:29:08 am
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */
import styled from "styled-components";

const Burger = styled.div.attrs(props => ({
    bgColor: props.bgColor,
    className: props.className
}))`
    height: 5px;
    width: 100%;
    background-color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
    display: block;
    border-radius: 5px;
    transition: 0.3s ease;
`;

export default Burger;
